const generateRandomNumber = (value: string[]) => {
  let newValue = Math.random();
  while (value.includes(newValue.toString())) {
    newValue = Math.random();
  }
  return newValue;
};

export default generateRandomNumber;
